export default __webpack_public_path__ + "static/media/nupy-logo.a25e27ce.png";